import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const REFUND_ENDPOINTS = {
  V1: createEndpoints('v1', {
    REFUND_IS_PAID: (orderID: number) => `/refund-is-paid/${orderID}/`,
    ORDER_COST_REFUNDS: (orderID: number) => `/order-cost-refunds/${orderID}/`,
    REFUND_REASONS: '/refund-reasons/',
    REFUND_TYPES: '/refund-types/',
    CALCULATE_REFUND_VALUE: (orderID: number) => `/calculate-refund-value/${orderID}/`,
  }),
} as const;
